const useDataLayer = () => {
    const pushToDataLayer = (eventData) => {
        if (window.dataLayer) {
            window.dataLayer.push(eventData);
        } else {
            console.warn('dataLayer is not initialized');
        }
    };

    return { pushToDataLayer };
};

export default useDataLayer;